import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  qrWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '20px',
  },
}));
